import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { AppTranslateModule } from '@core/app-translate.module';
import { FilePickerModule } from '@shared/file-picker/file-picker.module';
import { FileSizeModule } from '@shared/pipes/file-size/file-size.module';

import { FormFileInputComponent } from './form-file-input.component';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

export const imports: NgModule['imports'] = [
  FilePickerModule,
  FileSizeModule,
  FlexLayoutModule,
  MatButtonModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
];

@NgModule({
  declarations: [FormFileInputComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [FormFileInputComponent],
})
export class FormFileInputModule {}
